import React, { createContext, useContext } from "react";
import { Edge, Node } from "reactflow";
import * as Y from "yjs";

type YdocContextType = {
  ydoc: Y.Doc | undefined;
  nodesMap: Y.Map<Node> | undefined;
  edgesMap: Y.Map<Edge> | undefined;
};

export const YdocContext = createContext<YdocContextType | undefined>(undefined);

export function YdocProvider({
  ydoc,
  children,
}: {
  ydoc: Y.Doc | undefined;
  children: React.ReactNode;
}) {
  const nodesMap = ydoc?.getMap<Node>("nodes");
  const edgesMap = ydoc?.getMap<Edge>("edges");

  const value = { ydoc, nodesMap, edgesMap };

  return <YdocContext.Provider value={value}>{children}</YdocContext.Provider>;
}

/**
 * Hook for sharing editor between components
 */
export default function useYdoc() {
  const context = useContext(YdocContext);

  if (!context) {
    throw new Error(`useYdoc must be used within a YdocProvider`);
  }

  return context;
}
